import Vue from "vue";
import App from "./App.vue";
import "regenerator-runtime/runtime";
import VueHtml2Canvas from "vue-html2canvas";
import Vue2TouchEvents from "vue2-touch-events";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VFileInput from "v-file-input";
import axios from "axios";
import "firebase/firestore";
import { firestorePlugin } from "vuefire";
import VueGtag from "vue-gtag";

Vue.prototype.$http = axios;

Vue.use(VueHtml2Canvas);
Vue.use(VFileInput);

Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: "",
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
  namespace: "touch",
});

Vue.use(BootstrapVue);

Vue.use(IconsPlugin);

Vue.use(firestorePlugin);

Vue.use(VueGtag, {
  config: {
    id: "UA-1234567-1",
  },
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
